import React from 'react'
import { Box, Row, View, Column, SectionIntro } from 'components/Layout'

import {
	AppDistributionPrivateForm
	// AppDistributionPublicForm
} from '../../containers/Forms'

import { Image } from 'components/Image'

import { FormSection } from 'components/Form'

import goPublic from '../../assets/intros/guy-carry.png'

const AppDistribution = ({ props, match }) => (
	<View>
		<Row topMargin>
			<Column width={6}>
				<SectionIntro header={'Distribution'} />
			</Column>
		</Row>
		<Row>
			<Column width={6}>
				<AppDistributionPrivateForm match={match} />
			</Column>
		</Row>
		<Row>
			<Column width={6}>
				{/* <AppDistributionPublicForm match={match} /> */}
				<Box
					header={'For all other teams – coming soon'}
					body={
						<FormSection dark>
							<Row notPadded center>
								<Column width={2}>
									<Image
										src={goPublic}
										width={100}
										height={200}
										style={{ margin: '0 auto' }}
									/>
								</Column>
								<Column>
									<p>
										Reach other chat.io customers and other
										companies with your app.
									</p>
								</Column>
							</Row>
						</FormSection>
					}
				/>
			</Column>
		</Row>
	</View>
)

export default AppDistribution



// WEBPACK FOOTER //
// ./src/views/Apps/AppDistribution.js